<script setup lang="ts">
import {computed} from "vue";

interface Props {
    modelValue: string,
    title: string,
    label?: string,
    items: Array<{text: string, value: string}>,
    returnSelected?: boolean,
    btnClass?: string,
}

const props = withDefaults(defineProps<Props>(), {
    returnSelected: false,
    label: undefined,
    btnClass: undefined,
})
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
</script>

<template>
    <v-menu
        bottom
        offset-y
        close-on-click
    >
        <template #activator="{ props: attrs }">
            <v-btn
                variant="text"
                class="text-body-2 font-weight-regular"
                :class="btnClass"
                v-bind="attrs"
                size="small"
                append-icon="mdi-menu-down"
            >
                {{ title }}
            </v-btn>
        </template>

        <v-list
            density="compact"
            class="py-0 rounded"
        >
            <v-list-item
                v-if="label"
                class="border-bottom"
                density="compact"
            >
                <v-list-item-title class="text-caption font-weight-bold text--disabled">
                    {{ label }}
                </v-list-item-title>
            </v-list-item>
            <v-list-item
                v-for="(item, index) in items"
                :key="index"
                class="border-bottom"
                dense
                @click="$emit('update:modelValue', item.value)"
            >
                <template #prepend>
                    <v-icon
                        v-if="value === item.value"
                        size="x-small"
                    >
                        mdi-check
                    </v-icon>
                </template>
                <v-list-item-title class="text-caption font-weight-regular text-grey-darken-2">
                    {{ item.text }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<style scoped>
.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

:deep(.v-list-item__prepend) {
    width: 20px;
}
</style>
